import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { useCheckoutCartStore, useUserStore } from '@/store'

import { refreshSession } from './api/authApi'

interface AuthSessionProviderProps {
  children: React.ReactNode
}

export function AuthSessionProvider({ children }: AuthSessionProviderProps) {
  const authStatus = useUserStore((state) => state.authStatus)
  const setAuthenticated = useUserStore((state) => state.setAuthenticated)
  const clearSession = useUserStore((state) => state.clearSession)
  const clearSale = useCheckoutCartStore((state) => state.clearSale)
  const queryClient = useQueryClient()

  useEffect(() => {
    let cancelled = false

    void refreshSession()
      .then((session) => {
        if (!cancelled) {
          setAuthenticated(session.user, session.accessToken)
        }
      })
      .catch(() => {
        if (!cancelled) {
          clearSession()
        }
      })

    return () => {
      cancelled = true
    }
  }, [clearSession, setAuthenticated])

  useEffect(() => {
    if (authStatus === 'anonymous') {
      clearSale()
      queryClient.clear()
    }
  }, [authStatus, clearSale, queryClient])

  return children
}
